import { pendingUserGateway } from "@/gateways/pendingUserGateway";
import type { MutationCallbacks } from "@/types";
import { useMutation, useQuery } from "@tanstack/vue-query";
import type { PendingUserActivation } from "./types";

export function useGetPendingUserPreview(token: string) {
  const query = useQuery({
    queryKey: ["pendingUserPreviews", token],
    queryFn: () => pendingUserGateway.getPendingUserPreview(token),
  });

  return {
    ...query,
    getPendingUserStatus: query.status,
    pendingUser: query.data,
  };
}

export function useActivatePendingUser(
  token: string,
  callbacks: MutationCallbacks<void> = {},
) {
  const mutation = useMutation({
    mutationFn: (activation: PendingUserActivation) =>
      pendingUserGateway.activatePendingUser(token, activation),
    onSuccess: () => {
      if (callbacks.onSuccess) callbacks.onSuccess();
    },
  });

  return {
    ...mutation,
    activatePendingUserStatus: mutation.status,
    activatePendingUser: mutation.mutate,
  };
}
